export default __webpack_public_path__ + "static/S1-Item-a109b5be14cbb53b0f7e3ed5eda142e4.webp";